export default {
  'transactionDetails.accountNumber': 'Account Number',
  'transactionDetails.back': 'Back',
  'transactionDetails.routingNumber': 'Bank Code / Number',
  'transactionDetails.checkAmount': 'Check Amount',
  'transactionDetails.checkNumber': 'Check Number',
  'transactionDetails.depositAmount': 'Deposit Amount',
  'transactionDetails.image': 'Image',
  'transactionDetails.imageUnavailable':
    'Image is unavailable. Please try again later. If problem persists, contact your administrator or customer service',
  'transactionDetails.item': 'Item',
  'transactionDetails.itemNumber': 'Item Number',
  'transactionDetails.postDate': 'Post Date',
  'transactionDetails.postedOn': 'Deposit Date',
  'transactionDetails.serialNumber': 'Serial Number',
  'transactionDetails.transactionNumber': 'Transaction Number'
};
